import { Link } from 'react-router-dom';
import React, { useLayoutEffect, useRef, useState } from 'react'
import { SearchIcon, EyeIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon, PlusCircleIcon } from "@heroicons/react/outline";
import Layout from './../../components/Layout/Layout';
import UserServices from '../../services/UserServices';
import { useEffect } from 'react';
import * as RiIcons from "react-icons/ri";

const people = [
    {
        name: 'Calvin Hawkins',
        email: 'calvin.hawkins@example.com',
        status: 'Unread',
        time: '4.4.2019; 13:44'
    },
    {
        name: 'Kristen Ramos',
        email: 'kristen.ramos@example.com',
        status: 'Read',
        time: '4.4.2019; 13:44'
    },
    {
        name: 'Ted Fox',
        email: 'ted.fox@example.com',
        status: 'Unread',
        time: '4.4.2019; 13:44'
    },
]

const statusStyles = {
    Unread: 'text-orange-600',
}
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Notifications() {



    useEffect(() => {
    }, []);
    return (<>
        <Layout title="Notifications" pageTag={"admin"} current={'/notifications'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto '>
                        <div className="">
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">
                                    <div className="mt-1 relative rounded-md shadow-sm">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                        </div>
                                        <input
                                            type="text"
                                            name="user"
                                            id="user"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                            placeholder="Search users"
                                        />
                                    </div>
                                </div>
                                <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                                    <button
                                        type="button"
                                        className="inline-flex items-center justify-center rounded-md border border-transparent bg-slate-100 px-2 py-2 text-sm font-medium text-black shadow-sm  sm:w-auto"
                                    >
                                        <RiIcons.RiCalendar2Fill className="w-4 mr-1.5" />
                                        23 -30 March 2022
                                    </button>
                                </div>
                            </div>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div className="relative overflow-hidden  md:rounded-lg">
                                            <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
                                                <div className='col-span-2 flex flex-col text-left bg-white rounded-lg  '>
                                                    <ul role="list" className="">
                                                        {people.map((person) => (
                                                            <li key={person.email} className="py-4 flex">
                                                                <div className='flex w-full justify-between'>
                                                                    <div className="ml-3">
                                                                        <p className="text-sm font-medium text-gray-900">{person.name}</p>
                                                                        <p className="text-sm text-gray-500">{person.email}</p>
                                                                    </div>
                                                                    <div className="ml-3">
                                                                        <p className={classNames(
                                                                            statusStyles[person.status], "text-sm font-medium")}>{person.status == "Read" ? "" : person.status}</p>
                                                                        <p className="text-sm text-gray-500">{person.time}</p>
                                                                    </div>
                                                                </div>

                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                <div className='col-span-2 flex flex-col text-left bg-zinc-100  p-5'>
                                                    <p className='text-left'>The company is pivoting to a new market </p>
                                                    <p className='font-thin text-gray-400 text-sm'>Today, 9:15pm</p>

                                                    <p className='font-thin text-gray-400 text-sm'>For many of us, our very first experience of learning about the celestial bodies begins when we saw our first full moon in the sky. It is truly a magnificent view even to the naked eye. If the night is clear, you can see amazing detail of the lunar surface just star gazing on in your back yard.

                                                        Naturally, as you grow in your love of astronomy, you will find many celestial bodies fascinating. But the moon may always be our first love because is the one far away space object that has the unique distinction of flying close to the earth and upon which man has walked.

                                                        Your study of the moon, like anything else, can go from the simple to the very complex. To gaze at the moon with the naked eye, making yourself familiar with the lunar map will help you pick out the seas, craters and other geographic phenomenon that others have already mapped to make your study more enjoyable. Moon maps can be had from any astronomy shop or online and they are well worth the investment.

                                                        The best time to view the moon, obviously, is at night when there are few clouds and the weather is accommodating for a long and lasting study. The first quarter yields the greatest detail of study. And don’t be fooled but the blotting out of part of the moon when it is not in full moon stage. The phenomenon known as “earthshine
                                                        The best time to view the moon, obviously, is at night when there are few clouds and the weather is accommodating for a long and lasting study. The first quarter yields the greatest detail of study. And don’t be fooled but the blotting out of part of the moon when it is not in full moon stage. The phenomenon known as “earthshine</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        </Layout>

    </>);
}